<div class="relative flex flex-col h-[100%] w-full absolute ">
  
    <!-- Loading Overlay -->
    <div *ngIf="isLoading" class="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center gap-4" [@loadingAnimation]>
        <span class="text-[#111215ff] font-['archivo'] text-[18px]">Verifying authentication...</span>
    </div>

    <!-- Location Selection Modal -->
    <app-location-selection-modal
        [isOpen]="showLocationModal"
        [locations]="pendingLocations"
        (locationSelected)="onLocationConfirmed($event)"
    ></app-location-selection-modal>

    <!-- Main Content Area -->
    <div class="flex h-[100%] " [class.opacity-0]="isLoading" [class.pointer-events-none]="isLoading">
        <!-- Left Side - Background Image -->
        <div class="flex-1 relative overflow-hidden">
            <img 
                src="assets/images/loginbg.png" 
                alt="BakerRipley Community" 
                class="w-full h-[100%] object-cover"
                priority="high"
            >
        </div>

        <!-- Right Side - Sign In Panel -->
        <div class="w-[500px] bg-white flex flex-col gap-[40px] items-center justify-center px-[48px] py-[60px] page-content" [@pageLoad]="pageState" [class.fade-out]="isNavigating">

            <!-- Logo in Panel -->
            <div class="flex flex-col justify-center items-center gap-[8px]">
                <div class="">
                    <img src="assets/icons/BakerriplyTextLogo.svg" alt="BakerRipley Logo" class="h-[32px]">
                </div>

                <!-- Sign In Header -->
                <div class="flex flex-col items-center gap-[16px] w-full">
                    <h1 class="text-[#111215ff] text-center font-bold font-['archivo'] text-[28px] leading-[38px]">
                        Sign In
                    </h1>
                    <p class="text-[#444955] text-center font-normal font-['archivo'] text-[18px] leading-[26px]">
                        Sign in to manage and View check-In program
                    </p>
                </div>
            </div>

            <!-- Login Error Message -->
            <div *ngIf="loginError" class="w-full">
                <p class="text-red-500 text-[14px] font-archivo text-center bg-red-50 border border-red-200 rounded-[12px] py-[12px] px-[16px]">
                    {{ loginError }}
                </p>
            </div>

            <!-- Sign In Button -->
            <div class="w-full flex justify-center items-center">
                <NiButton 
                    [label]="isSubmitting ? 'Logging in...' : 'Use my BakerRipley Login'" 
                    [loading]="isSubmitting"
                    [loadingText]="'Logging in...'"
                    bg="primary-500"
                    text="white"
                    hoverBg="primary-600"
                    px="[12px]"
                    py="[16px]"
                    rounded="full"
                    fontSize="[20px]"
                    fontWeight="bold"
                    w="[350px]"
                    [disabled]="!isLoginEnabled"
                    styleClass="relative group overflow-hidden transition-all duration-300 ease-out justify-center items-center font-archivo line-height-[29px] tracking-[0.5px]"
                    (onClick)="onSubmit()"
                >
                </NiButton>
            </div>

        </div>
    </div>
</div>
